import {AdditionalFilter, AllFields} from './chartFilters';
import {Chart} from './chart';

export enum StoryboardAccessType {
    Write = 'write',
    Read = 'read',
}

export interface StoryboardAccess {
    id: number;
    accessType: StoryboardAccessType;
    username: string;
}

export interface Storyboard {
    id: number;
    slug?: string;
    storySlug?: string;
    title: string;
    hashid: string;
    storyOwnerId: number;
    createdById: number;
    relatedUsers: StoryboardAccess[],
    userIsStoryAdmin: boolean,
    globalFilters: {
        all_fields: AllFields,
        additional_filters: AdditionalFilter[],
    },
    storyHashid: string;
    storyId: number;
    storyboardStoryInfo: string;
    storyIsPublic: boolean;
    storyTitle: string;
    charts: Chart[],
    storyAssignedUrl: string | null;
    writeAccess: boolean,
    userIsStoryOwner: boolean;
}
